import React, { useEffect, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
  Download,
  Briefcase,
  User,
  Building2,
  CalendarDays,
} from "lucide-react";

import Layout, { Container } from "../components/layout";
import { apiurl } from "../config/config";
import { getCookie } from "../config/webStorage";

const IJPRequests = () => {

    const getStatusBadge = (status) => {
  const map = {
    PENDING: "bg-yellow-100 text-yellow-700",
    APPROVED: "bg-green-100 text-green-700",
    REJECTED: "bg-red-100 text-red-700",
    ON_HOLD: "bg-gray-100 text-gray-700",
    RECOMMENDED: "bg-blue-100 text-blue-700",
  };
  return map[status] || "bg-gray-100 text-gray-600";
};


  const [list, setList] = useState([]);
  const token = getCookie("swtoken");

  useEffect(() => {
    fetchListing();
  }, []);

  const fetchListing = async () => {
    try {
      const res = await axios.get(`${apiurl}/api/ijp/request/get`, {
        headers: { Authorization: `${token}` },
      });
      setList(res.data.data || []);
    } catch (err) {
      console.error("Error fetching IJP listing", err);
    }
  };

  /* ================= EXCEL ================= */
  const downloadExcel = () => {
    const excelData = list.map((item, i) => ({
      "#": i + 1,
      "Employee Name": item.employeeName,
      "Employee ID": item.employeeId,
      "Current Role": item.currentRole,
      "Current Dept": item.currentDepartment,
      "Applied Role": item.appliedRole,
      "Applied Dept": item.appliedDepartment,
      "Manager Status": item.managerStatus,
      "HR Status": item.hrStatus,
      "Final Action": item.finalAction,
      "Date Of Joining": new Date(item.dateOfJoining).toLocaleDateString(),
      "Applied On": new Date(item.createdAt).toLocaleDateString(),
      Reason: item.reason,
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "IJP Requests");

    const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([buffer]), "IJP_Requests.xlsx");
  };

  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="py-6">
          {/* HEADER */}
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-semibold">IJP Requests</h2>

            <button
              onClick={downloadExcel}
              className="flex items-center gap-2 bg-indigo-600 px-4 py-2 rounded-xl text-white hover:bg-indigo-700"
            >
              <Download size={18} />
              Excel
            </button>
          </div>

          {/* LIST */}
          {list.length === 0 ? (
            <div className="text-center text-gray-500">
              No IJP requests found
            </div>
          ) : (
            <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-3">
              {list.map((item) => (
                <div
                  key={item._id}
                  className="rounded-2xl border bg-white p-5 shadow-sm hover:shadow-md transition"
                >
                  {/* EMPLOYEE */}
                  <div className="flex items-center gap-3">
                    <User className="text-indigo-600" />
                    <div>
                      <p className="font-semibold capitalize">
                        {item.employeeName}
                      </p>
                      <p className="text-xs text-gray-500">
                        ID: {item.employeeId}
                      </p>
                    </div>
                  </div>

                  {/* CURRENT → APPLIED */}
                  <div className="mt-4 text-sm text-gray-600 space-y-2">
                    <div className="flex items-center gap-2">
                      <Briefcase size={16} />
                      {item.currentRole} →{" "}
                      <span className="font-medium text-gray-800">
                        {item.appliedRole}
                      </span>
                    </div>

                    <div className="flex items-center gap-2">
                      <Building2 size={16} />
                      {item.currentDepartment} →{" "}
                      <span className="font-medium text-gray-800">
                        {item.appliedDepartment}
                      </span>
                    </div>

                    <div className="flex items-center gap-2">
                      <CalendarDays size={16} />
                      DOJ:{" "}
                      {new Date(item.dateOfJoining).toLocaleDateString()}
                    </div>
                  </div>

                  {/* REASON */}
                  <p className="mt-3 text-sm text-gray-500 line-clamp-2">
                    <b>Reason:</b> {item.reason}
                  </p>

                  {/* STATUS */}
                  <div className="mt-4 flex flex-wrap gap-2 text-xs">
                    <span className={`px-3 py-1 rounded-full ${getStatusBadge(item.managerStatus)}`}>
                      Manager: {item.managerStatus}
                    </span>
                    <span className={`px-3 py-1 rounded-full ${getStatusBadge(item.hrStatus)}`}>
                      HR: {item.hrStatus}
                    </span>
                    <span className="px-3 py-1 rounded-full bg-indigo-100 text-indigo-700">
                      Action: {item.finalAction}
                    </span>
                  </div>

                  {/* DATE */}
                  <p className="mt-3 text-xs text-gray-400">
                    Applied on {new Date(item.createdAt).toLocaleDateString()}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
      </Container>
    </Layout>
  );
};

export default IJPRequests;